<template lang="pug" src="./order-details.pug"></template>
<style lang="scss" src="./order-details.scss" scoped></style>

<script>
import request from "@/utils/request";
import { mapState } from 'vuex';
import orderTable from '../order-table';
import searchField from '@/components/search-field';

export default {
    components: {
        'v-order-table': orderTable,
        'v-search-field': searchField
    },
    data: () => ({
        orderId: null,
        isSearchEnabled: true,
        showPayments: false,
        showFpPayments: false,
        orderData: [],
        loading: false
    }),
    computed: {
        ...mapState({
            payments: state => state.technicalSupport.payments,
            fpPayments: state => state.technicalSupport.fpPayments,
            orderHistories: state => state.orders.orderHistories,
            cardOrderId: state => state.technicalSupport.cardData && state.technicalSupport.cardData.orderId
        }),
        paymentsHeaders() {
            return ['createdAt', 'fullNameForPayment', 'paymentComment', 'paymentSum'].map(it => ({
                text: this.$vuetify.lang.t(`$vuetify.pages.Users.payments.${it}`),
                value: it,
                sortable: false,
                align: 'center'
            }));
        },
        fpPaymentsHeaders() {
            return ['orderId', 'amount', 'status', 'createdAt'].map(it => ({
                text: this.$vuetify.lang.t(`$vuetify.pages.TechnicalSupport.additionalInfo.fpPaymentsTable.${it}`),
                value: it,
                sortable: false,
                align: 'center'
            }));
        }
    },
    watch: {
        orderId(value) {
            this.isSearchEnabled = !!value;
        },
        cardOrderId(value) {
            if (value) {
                this.orderId = value;
            }
        }
    },
    methods: {
        getPayments() {
            if (!this.showPayments) {
                return this.$store.commit('technicalSupport/SET_PAYMENTS', []);
            }

            this.$store.dispatch('technicalSupport/getPayments', {
                orderId: this.orderId
            }).then(() => this.handleEmptyPayments('payments', 'showPayments'));
        },
        getFpPayments() {
            if (!this.showFpPayments) {
                return this.$store.commit('technicalSupport/SET_FP_PAYMENTS', []);
            }

            this.$store.dispatch('technicalSupport/getPayments', {
                orderId: this.orderId,
                fromFp: true
            }).then(() => {
                this.handleEmptyPayments('fpPayments', 'showFpPayments');
            });
        },
        async getOrderInfo() {
            this.resetData();

            if (this.loading) return;
            this.loading = true;

            await request({
                url: `/support/order/${this.orderId}`,
                method: 'get'
            }).then(res => {
                if (res.data && res.data.order) {
                    this.orderData.push(res.data.order);
                }
            }).catch(err => {
                if (err.response && err.response.data && err.response.data.error) {
                    this.$store.dispatch('alert/addMessage', {
                        message: 'support.orderNotFound'
                    });
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        handleEmptyPayments(payments, toggle) {
            // Common handler to check if system payments or fp payments are not empty.
            this.$nextTick(() => {
                if (!this[payments].length) {
                    this.$store.dispatch('alert/addMessage', {
                        type: 'error',
                        message: 'support.paymentsNotFound'
                    });

                    this[toggle] = false;
                }
            });
        },
        resetData() {
            this.$store.commit('technicalSupport/SET_PAYMENTS', []);
            this.$store.commit('technicalSupport/SET_FP_PAYMENTS', []);
            this.showFpPayments = false;
            this.showPayments = false;
            this.orderData = [];
        }
    }
};
</script>
